import { createEntry, insertCss } from "@/helpers/entriesHelper";
import Teaser from "../views/Teaser/Teaser.vue";
createEntry(Teaser, "eopoi-teaser-widget");
insertCss();
